import z from "zod";
import { MetaSchema } from "./shared";

export const CreateOrderBodySchema = z.object({
  baseCurrency: z.string(),
  quoteCurrency: z.string(),
  orderType: z.enum(["market", "limit"]),
  positionType: z.enum(["long", "short"]),
  leverage: z.number(),
  amount: z.number(),
  takeProfit: z.number().optional(),
  stopLoss: z.number().optional(),
});
export type CreateOrderBodyType = z.infer<typeof CreateOrderBodySchema>;

export const OrderUserSchema = z.object({
  id: z.string().uuid(),
});

export const OrderSchema = z.object({
  baseCurrency: z.string(),
  quoteCurrency: z.string(),

  entryPrice: z.number(),
  liquidationPrice: z.number(),

  amount: z.number(),

  positionType: z.string(),
  positionFee: z.number(),

  type: z.string(),
  status: z.string(),

  leverage: z.string(),

  takeProfit: z.number().nullable(),
  stopLoss: z.number().nullable(),

  user: OrderUserSchema,

  id: z.string().uuid(),
  createdAt: z.string().datetime(),
});

export const CreateOrderDataSchema = OrderSchema;

const CreateOrderResponse = z.object({
  data: CreateOrderDataSchema.optional(),
  meta: MetaSchema.default,
  message: z.string().optional(),
  statusCode: z.number().optional(),
});

export type CreateOrderResponseType = z.infer<typeof CreateOrderResponse>;

export default CreateOrderResponse;
